export function updateTicketsState(state, payload) {
  state[payload.state] = payload.data;
}

export function toggleShowAll(state, payload) {
  state['showAll'] = payload;
}
